import React from 'react';
import './Customers.css';
import { BlocksIcon } from '../BlocksIcon';
import { SettingsIcon } from '../SettingsIcon';
import { BoltIcon } from '../BoltIcon';
import { ZapIcon } from '../ZapIcon';

const Customers = () => {
  const industries = [
    { icon: <BlocksIcon size={32} />, name: 'Automotives' },
    { icon: <SettingsIcon size={32} />, name: 'Valves & Actuators' },
    { icon: <BoltIcon size={32} />, name: 'Glass & Rubber' },
    { icon: <BoltIcon size={32} />, name: 'Battery' },
    { icon: <ZapIcon size={32} />, name: 'Aerospace' },
    { icon: <BlocksIcon size={32} />, name: 'Agricultural Machineries' },
    { icon: <BoltIcon size={32} />, name: 'Chemical Industry' },
  ];

  
  return (
    <section id="customers" className="customers">
      <div className="container">
        <div className="customers-header">
          <h2 className="section-title">Our Valuable Customers</h2>
          <p className="section-description">
            Trusted by leading industries across diverse sectors for their packaging and shipping needs
          </p>
        </div>

        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div key={index} className="industry-card">
              <div className="industry-icon">{industry.icon}</div>
              <h3 className="industry-name">{industry.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Customers;
